<template>
  <div class='page-function'>
    <div class="search-form">
      <el-form inline>
        <el-form-item label="功能名称">
          <el-input
            placeholder="请输入"
            v-model.trim="originData.menuName"
          ></el-input>
        </el-form-item>
        <el-form-item label="功能url">
          <el-input
            v-model.trim="originData.menuUrl"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="归属菜单">
          <yh-select-tree
            :width="230"
            clearable
            :icon="getIconType(originData.menuType)"
            class="input--large"
            :data="getSelectableMenu(menuData, '2')"
            placeholder="请选择归属的最后一级菜单"
            :value="originData.parentName"
            @change="(data) => handleSelectChange('originData', data)"
            :render-content="renderSearchTreeItem"
          />
        </el-form-item>
      </el-form>
    </div>
    <section class='flex-between'>
      <div>
        <el-button
          type="primary"
          size="small"
          @click='handleSearchClick'
        >查询</el-button>
        <el-button
          size="small"
          @click='handleResetClick'
        >清空查询条件</el-button>
      </div>
      <div>
        <el-button
          v-if="functionList.includes('321102563881226240')"
          size="small"
          @click="visibleAdd = true"
        >新增功能</el-button>
      </div>
    </section>

    <el-table
      border
      :data="tableData"
    >
      <template slot="empty">
        {{emptyText}}
      </template>
      <el-table-column
        v-for="item in propMap"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.width"
      >
        <template slot-scope="scope">
          {{scope.row[item.prop] | blankValue}}
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        label='创建时间'
        prop="createTime"
      >
        <template slot-scope="scope">
          {{scope.row.createTime | formatTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="创建人ID"
        min-width="200"
      >
        <template slot-scope="scope">{{scope.row.createUserid | blankValue}}</template>
      </el-table-column>
      <el-table-column
        width="200"
        label='修改时间'
        prop="updateTime"
      >
        <template slot-scope="scope">
          {{scope.row.updateTime | formatTime | blankValue}}
        </template>
      </el-table-column>
      <el-table-column
        label="修改人ID"
        min-width="200"
      >
        <template slot-scope="scope">
          {{scope.row.updateUserid | blankValue}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        min-width="100"
        class="feature-container"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              v-if="functionList.includes('321102666826223616')"
              @click="editFormData = JSON.parse(JSON.stringify(scope.row));visibleEdit = true"
            >修改</span>
            <span
              class="button--red"
              v-if="functionList.includes('321102750053797888')"
              @click="handleDeleteClick(scope.row)"
            >删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <!-- 弹框 -->
    <yh-dialog
      title="新增功能"
      :visible.sync="visibleAdd"
    >
      <el-form
        class="hide-error"
        label-width="100px"
        ref="addForm"
        :model="addFormData"
        inline
      >
        <el-form-item
          label="功能名称"
          prop="menuName"
          required
        >
          <el-input
            v-model.trim="addFormData.menuName"
            placeholder="请输入功能名称，不超过20字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="功能url"
          prop="menuUrl"
          required
        >
          <el-input
            v-model.trim="addFormData.menuUrl"
            placeholder="请输入功能url，不超过200字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="功能描述"
          prop="menuDesc"
        >
          <el-input
            v-model="addFormData.menuDesc"
            type="textarea"
            placeholder="请输入功能描述，不超过200字"
            autosize
          ></el-input>
        </el-form-item>
        <el-form-item
          label="归属菜单/父功能"
          prop="parentName"
          required
        >
          <yh-select-tree
            clearable
            :width="320"
            :icon="getIconType(addFormData.menuType)"
            placeholder="请选择叶子菜单或父功能"
            :data="getSelectableMenu(menuData,  '2', '3')"
            :value="addFormData.parentName"
            @change="(data) => handleSelectChange('addFormData', data)"
            :render-content="renderTreeItem"
          />
        </el-form-item>
        <el-form-item
          style="display:none;"
          prop="parentId"
        ></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visibleAdd=false">取消</el-button>
        <yh-button
          type="primary"
          @click="handleAddConfirmClick"
        >新增功能</yh-button>
      </span>
    </yh-dialog>
    <yh-dialog
      title="修改功能"
      :visible.sync="visibleEdit"
    >
      <el-form
        class="hide-error"
        ref="editForm"
        :model="editFormData"
        inline
      >
        <el-form-item label="功能ID">
          <el-input
            disabled
            v-model="editFormData.id"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="功能名称"
          prop="menuName"
          required
        >
          <el-input
            v-model.trim="editFormData.menuName"
            placeholder="请输入功能名称，不超过20字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="功能url"
          prop="menuUrl"
          required
        >
          <el-input
            v-model.trim="editFormData.menuUrl"
            placeholder="请输入功能url，不超过200字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="功能描述"
          prop="menuDesc"
        >
          <el-input
            v-model="editFormData.menuDesc"
            type="textarea"
            placeholder="请输入功能描述，不超过200字"
            autosize
          ></el-input>
        </el-form-item>
        <el-form-item
          label="归属菜单/父功能"
          prop="parentName"
          required
        >
          <yh-select-tree
            :width="320"
            :icon="getIconType(editFormData.menuType)"
            placeholder="请选择叶子菜单或父功能"
            disabled
            :value="editFormData.parentName"
          />
        </el-form-item>
        <el-form-item
          style="display:none;"
          prop="parentId"
        ></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visibleEdit=false">取消</el-button>
        <yh-button
          type="primary"
          @click="handleEditConfirmClick"
        >保存</yh-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
import {
  getFunctionList,
  clearBy,
  pageCount,
  pickBy,
  getPagingData,
} from '@/mixins';

export default {
  name: 'FunctionManagement',
  mixins: [getFunctionList, clearBy, pageCount, pickBy, getPagingData],
  data() {
    function disableNode(data, ...allowedTypes) {
      return allowedTypes.includes(data.menuType);
    }
    const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      userId,
      defaultProps: {
        disable: disableNode,
      },
      choseMenuDialog: false,
      parentName: '',
      emptyText: this.$LS.empty,
      visibleAdd: false,
      visibleEdit: false,
      propMap: [{
        label: '功能ID',
        prop: 'id',
        width: '200',
      }, {
        label: '功能名称',
        prop: 'menuName',
        width: '200',
      }, {
        label: '功能url',
        prop: 'menuUrl',
        width: '300',
      }, {
        label: '功能描述',
        prop: 'menuDesc',
        width: '300',
      }, {
        label: '归属菜单',
        prop: 'parentName',
        width: '200',
      }, {
        label: '父功能',
        prop: 'parentFeature',
        width: 300,
      }],
      // 功能状态
      funcStatus: [
        {
          label: '启用',
          value: '1',
        },
        {
          label: '禁用',
          value: '0',
        },
      ],
      menuData: [],
      functionList: [],
      nodeData: {},
      // 新增/修改数据框数据
      addFormData: {
        parentName: '',
        parentId: '',
        menuName: '',
        menuDesc: '',
        menuType: '',
        menuUrl: '',
      },
      editFormData: {
        id: '',
        parentName: '',
        parentId: '',
        menuName: '',
        menuDesc: '',
        menuType: '',
        menuUrl: '',
      },
      addDialog: false,
      editDialog: false,
      currentPage: 1,
      pageSize: 10,
      sumCount: 0,
      tableData: [],
      originData: {
        menuName: '',
        parentId: '',
        menuUrl: '',
        parentName: '',
      },
      // 选中的查询条件对象
      searchParam: {
        menuName: '',
        parentId: '',
        menuUrl: '',
        parentName: '',
      },
    };
  },
  computed: {
    searchMenuTree() {
      return this.getSelectableMenu(this.menuData, '2');
    },
  },
  watch: {
    visibleAdd(v) {
      if (!v) {
        this.$refs.addForm.resetFields();
      }
    },
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  methods: {
    // 根据传入的节点 type，递归获取可被选择的节点
    getSelectableMenu(menu, ...types) {
      return menu.map((item) => {
        const cloned = JSON.parse(JSON.stringify(item));
        if (!types.includes(cloned.menuType)) {
          cloned.disabled = true;
        }
        if (cloned.children) {
          cloned.children = this.getSelectableMenu(cloned.children, ...types);
        }
        return cloned;
      });
    },
    // 不同类型的节点，返回不同类型的 icon
    getIconType(menuType) {
      const iconMap = {
        0: 'el-icon-menu',
        1: 'el-icon-menu',
        2: 'el-icon-menu',
        3: 'el-icon-s-tools',
        4: 'el-icon-s-tools',
      };
      return iconMap[menuType];
    },
    handleSelectChange(name, data) {
      this[name].parentName = data.menuName;
      this[name].parentId = data.id;
      this[name].menuType = data.menuType;
    },
    // 渲染 el-tree 字节点
    renderTreeItem(h, { data }) {
      const iconMap = {
        0: <i class="el-icon-menu" style="color:#C0C4CC"></i>,
        1: <i class="el-icon-menu" style="color:#C0C4CC"></i>,
        2: <i class="el-icon-menu" style="color:#C0C4CC"></i>,
        3: <i class="el-icon-s-tools" style="color:#C0C4CC"></i>,
        4: <i class="el-icon-s-tools" style="color:#C0C4CC"></i>,
      };
      let className = 'ellipsis';
      if (data.menuType === '0' || data.menuType === '1' || data.menuType === '4') {
        className = 'ellipsis not-allowed';
      }
      if (data.menuName?.length >= 9) {
        return <el-tooltip placement="right" content={data.menuName}>
        <span
          class={className} style="width: 80px;">{iconMap[data.menuType]}{data.menuName}</span>
        </el-tooltip>;
      }
      return (
        <span
        class={className}>{iconMap[data.menuType]}{data.menuName}</span>
      );
    },
    renderSearchTreeItem(h, { data }) {
      const iconMap = {
        0: <i class="el-icon-menu" style="color:#C0C4CC"></i>,
        1: <i class="el-icon-menu" style="color:#C0C4CC"></i>,
        2: <i class="el-icon-menu" style="color:#C0C4CC"></i>,
        3: <i class="el-icon-s-tools" style="color:#C0C4CC"></i>,
        4: <i class="el-icon-s-tools" style="color:#C0C4CC"></i>,
      };
      let className = 'ellipsis';
      if (data.menuType !== '2') {
        className = 'ellipsis not-allowed';
      }
      if (data.menuName?.length >= 6) {
        return <el-tooltip placement="right" content={data.menuName}>
        <span
          class={className} style="width: 80px;">{iconMap[data.menuType]}{data.menuName}</span>
        </el-tooltip>;
      }
      return (
        <span
          class={className}>{iconMap[data.menuType]}{data.menuName}</span>
      );
    },
    // 重置按钮点击事件
    handleResetClick() {
      this.clear(this.originData);
    },
    // 查询按钮点击事件
    handleSearchClick() {
      this.searchParam = { ...this.originData };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    },
    // 重置查询条件
    clear(data) {
      Object.keys(data).forEach((key) => {
        // eslint-disable-next-line no-param-reassign
        data[key] = '';
      });
    },
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.functionDataList);
    },
    // 获取菜单树节点数据
    getNodeData(n) {
      if (!n.children && String(n.type) !== '0') {
        this.nodeData = n;
      } else {
        this.nodeData = [];
      }
    },
    handleEditConfirmClick() {
      if (!this.checkFormData('editFormData')) {
        return;
      }
      this.$_yh_confirm('此操作将修改一条数据, 是否继续?').then(() => {
        this.editDialog = false;
        const params = {
          data: {
            ...this.pickBy(this.editFormData, 'id', 'parentId', 'menuDesc', 'menuType', 'menuName', 'menuUrl'),
            updateUserid: this.userId,
          },
        };
        this.updateFunction(params);
      });
    },
    // 新增/修改前检测
    checkFormData(dataName) {
      function lessThan(n) {
        return v => v.length <= n;
      }
      const rules = [
        {
          prop: 'menuName',
          message: this.$MSG.M0097,
          validations: [
            {
              message: this.$MSG.M0098,
              validate: lessThan(20),
            },
          ],
        },
        {
          prop: 'menuUrl',
          message: this.$MSG.M0106,
          validations: [{
            message: this.$MSG.M0107,
            validate: lessThan(200),
          }],
        }, {
          prop: 'menuDesc',
          required: false,
          validations: [{
            message: this.$MSG.M0100,
            validate: lessThan(200),
          }],
        },
        {
          prop: 'parentId',
          message: this.$MSG.M0101,
        },
      ];
      return this.validate(rules, this[dataName]);
    },
    // 新增提示框
    handleAddConfirmClick() {
      if (!this.checkFormData('addFormData')) {
        return;
      }
      this.$_yh_confirm('此操作将增加一条数据, 是否继续?').then(() => {
        this.postFunction();
      });
    },
    // 新增功能
    postFunction() {
      // 如果父级 menuType 为 3，则 menuType 需被置为 4
      let { menuType } = this.addFormData;
      if (menuType === '3') {
        menuType = '4';
      } else {
        menuType = '3';
      }
      const params = {
        data: {
          ...this.pickBy(
            this.addFormData,
            'menuName',
            'parentId',
            'menuDesc',
            'menuUrl',
          ),
          menuType,
          createUserid: this.userId,
        },
      };
      return this.$_post(this.$API.functionSave, params).then((res) => {
        switch (res.errorCode) {
          case this.$CODE.existFunctionName:
            this.$message.warning(this.$MSG.M0099);
            break;
          case this.$CODE.success:
            this.visibleAdd = !this.visibleAdd;
            this.$message.success(this.$MSG.M0031);
            break;
          default:
            this.$message.error(this.$MSG.M0030);
        }
        this.getTableData();
      });
    },
    updateFunction(params) {
      return this.$_post(this.$API.functionUpdate, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.visibleEdit = false;
          this.$message.success(this.$MSG.M0031);
          this.getTableData();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 删除按钮
    handleDeleteClick(row) {
      this.$_yh_confirm(`确定要删除“${row.menuName}”功能？`).then(() => {
        this.deleteFunction(row);
      });
    },
    // 删除行
    deleteFunction(row) {
      const params = {
        data: {
          id: row.id,
          updateUserid: this.userId,
        },
      };
      return this.$_post(this.$API.functionDelete, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.getTableData();
          this.$message.success(this.$MSG.M0031);
        } else if (res.errorCode === this.$CODE.existSon) {
          this.$_yh_alert(this.$MSG.M0104);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page-function {
  position: relative;
}
</style>
<style lang="scss">
.not-allowed {
  cursor: not-allowed;
}
.input--large .el-input {
  width: 230px;
}
</style>
